import { useEffect, useState } from "react";
import { getOtpTimer, resetOtpCookie } from "@/app/auth/otp-cookie";

export function useOtpTimer(email: string, cooldown: number) {
  const [remainingSeconds, setRemainingSeconds] = useState<number>(cooldown);

  useEffect(() => {
    if (!email) return;
    let mounted = true;
    const fetchOtpTimer = async () => {
      const timer = await getOtpTimer(email);
      if (!mounted) return;
      if (timer?.lastSent === undefined) {
        await resetOtpCookie(email);
        setRemainingSeconds(cooldown);
      } else {
        setRemainingSeconds(timer?.remainingSeconds ?? 0);
      }
    };
    fetchOtpTimer();
    return () => {
      mounted = false;
    };
  }, [email, cooldown]);

  useEffect(() => {
    if (remainingSeconds <= 0) return;
    const interval = setInterval(() => {
      setRemainingSeconds((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => clearInterval(interval);
  }, [remainingSeconds]);

  return { remainingSeconds, setRemainingSeconds } as const;
}
